var $cc8cbf248c4ac933$exports = {};
$cc8cbf248c4ac933$exports = {
    "alert": `\u{62A}\u{646}\u{628}\u{64A}\u{647}`,
    "dismiss": `\u{62A}\u{62C}\u{627}\u{647}\u{644}`
};


export {$cc8cbf248c4ac933$exports as default};
//# sourceMappingURL=ar-AE.module.js.map
